'use client'

import ProfileForm from '@/entities/profile-page/ProfileForm'
import { useInView } from 'react-intersection-observer'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import {
    useCheckUserMutation,
} from '@/shared/api-rtk/index.js'
import React, { useEffect, useState } from 'react'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { reset } from '@/shared/store/slice/cartSlice.js'
import { navigationProfile } from '@/features/profile-page/TabBarProfile/navigationStorage.jsx'
import { useGetCountProductsQuery } from '@/shared/api-rtk/api-list/cartApi.js'

export const ProfileChapter = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    const [userData, setUserData] = useState() 
    // ОБЯЗАТЕЛЬНО УБРАТЬ
    const { userInfo } = useGetIsAuthUser()
    const [checkProfile] = useCheckUserMutation()

    useEffect(() => {
        checkProfile(userInfo)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setUserData(res.data)
                } else {
                    //TOAST_ERROR('Ошибка получения профиля. Попробуйте позже');
                    localStorage.removeItem('userInfo')
                    localStorage.removeItem('persist:root')
                    location.href = '/login'
                }
            })
    }, [])

    return (
        <div
            ref={ref}
            className={`ProfileChapter ${
                inView && 'animate__animated animate__zoomInRight'
            }`}
        >
            <h2>Профиль</h2>
            <h3>Контактная информация</h3>
            <div className={'profile-content'}>
                {userData && <ProfileForm infoUser={userData} />}
            </div>
        </div>
    )
}
